import React from 'react';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { Box, Grid, IconButton, Stack, Typography } from '@mui/material';

import { DialogUI } from '../Interface';
import { sxConfig } from './otherActivityReportPage.style';
import { getIcon } from '../../utils/helper';

const OtherActivityReportReasonDialog = ({ open, handleClose, data, onSelect }) => {
  const handleClick = (code) => onSelect(code);

  return (
    <DialogUI open={open} onClose={handleClose} headerContent="Megszakítás Ok kiválasztása" sx={sxConfig.reasonDialog}>
      <Box sx={sxConfig.reasonDialogBackButtonWrapper}>
        <IconButton size="small" onClick={handleClose}>
          <Stack direction="row" spacing={0.5} alignItems="center" sx={sxConfig.reasonDialogBackButton}>
            <KeyboardBackspaceIcon sx={sxConfig.reasonDialogBackIcon} />

            <Typography component="span" sx={sxConfig.reasonDialogBackText}>
              Vissza
            </Typography>
          </Stack>
        </IconButton>
      </Box>

      <Grid container justifyContent="center">
        {data.length > 0 &&
          data.map((item) => (
            <Grid item xs={6} sm="auto" sx={sxConfig.reasonGridItem} key={item.code}>
              <Stack onClick={() => handleClick(item.code)} sx={sxConfig.reasonCard}>
                <IconButton disableRipple tabIndex={-1}>
                  {getIcon(item.icon, '2.5rem', '#014AB1')}
                </IconButton>
                <Typography sx={sxConfig.reasonCardText}>{item.name}</Typography>
              </Stack>
            </Grid>
          ))}
      </Grid>
    </DialogUI>
  );
};

export default OtherActivityReportReasonDialog;
